import { render, staticRenderFns } from "./WalletSummaryTab.vue?vue&type=template&id=1c336e88&"
import script from "./WalletSummaryTab.vue?vue&type=script&lang=js&"
export * from "./WalletSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports